import _ from 'lodash';

export default function errorHandler(
  error: Error,
  defaultErrorMessage: string,
) {
  if (error && error.name === 'NetworkError') {
    return 'Você parece estar sem acesso à internet...';
  }

  return _.get(error, 'response.message', defaultErrorMessage);
}
